import { Input, InputProps, Select, SelectProps } from 'antd';
import { FC, useState } from 'react';

import { DomainPunycode } from '@/common/components';

import { DomainsInputMode } from '../DomainsCreateFormContainer';

import { useUpdateEffect } from 'ahooks';
import './DomainsFormDomainsInputWithMods.scss';

interface Props {
  formType: 'create' | 'edit';
  domainsMode: DomainsInputMode | null;
  disabled: boolean;
  initialNames: string[];
  setFieldValue: (value: string[]) => void;
}

const maxDomains = 50;

export const DomainsFormDomainsInputWithMods: FC<Props> = ({
  initialNames,
  domainsMode,
  formType,
  disabled,
  setFieldValue
}) => {
  const [domains, setDomains] = useState<string[]>(initialNames);

  useUpdateEffect(() => {
    if (domainsMode === 'single') {
      domains[0] && setFieldValue([domains[0]]);
    }
    if (domainsMode === 'multiple') {
      setFieldValue(domains);
    }
  }, [domains, domainsMode]);

  const handleAddElement: SelectProps['onSelect'] = (value: string): void => {
    if ((!value.includes('.') && value.split('.').length < 2) || domains.length >= maxDomains) return;

    setDomains(pr => pr.length >= maxDomains
      ? pr
      : [...pr, DomainPunycode.stringFormat(value.replace(/^www\./gim, '').trim().toLowerCase())]
    );
  };

  const handleRemoveElement: SelectProps['onDeselect'] = (value: string): void => {
    setDomains(pr => pr.filter((el) => el !== value));
  };

  const handleClear: SelectProps['onClear'] = (): void => {
    setDomains([]);
  };

  const handleChange: InputProps['onChange'] = (e): void => {
    setDomains([DomainPunycode.stringFormat(e.target.value.replace(/^www\./gim, '').trim().toLowerCase())]);
  };

  if (formType === 'edit' || domainsMode === 'single') {
    return (
      <Input
        allowClear
        disabled={ disabled }
        placeholder="Введіть назву домену"
        value={ domains[0] }
        onChange={ handleChange }
      />
    );
  } else {
    return (
      <Select
        maxCount={ maxDomains }
        className="domains-select-multiple"
        mode="tags"
        placeholder="Введіть назви доменів"
        showSearch={ false }
        style={{ width: '100%' }}
        value={ domains }
        options={ domains.map((el) => ({ value: el, label: el })) }
        disabled={ disabled }
        allowClear
        tokenSeparators={ [' '] }
        onSelect={ handleAddElement }
        onDeselect={ handleRemoveElement }
        onClear={ handleClear }
        suffixIcon={ <>{ domains.length } / { maxDomains }</> }
      />
    );
  }
};
